import { MarcaCompania } from "@/componentes/impresos/MarcaCompania"
import { Ondas } from "@/componentes/impresos/Ondas"
import { dato, filete, titular, versal } from "./estilo"
import { MEDIDAS } from "./medidas"
import type { DatosEtiquetaCarpeta } from "./tipos"

/** Cuatro bandas aunque estén vacías: dos carpetas seguidas se tienen que ver iguales. */
const BANDAS = 4

/** La etiqueta de la tapa: qué es la carpeta y, numerado, qué lleva dentro. */
export function EtiquetaCarpeta({ datos }: { datos: DatosEtiquetaCarpeta }) {
  const { ancho, alto } = MEDIDAS.ETIQUETA_CARPETA
  const total = Math.max(BANDAS, datos.secciones.length)
  const apretada = total > BANDAS
  const encabezado = ["Expediente para archivo", datos.siglas].filter(Boolean).join(" · ")
  const versalita = [datos.seccion_archivo, datos.periodo].filter(Boolean).join(" · ")

  return (
    <article
      className="pieza-impresa"
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: apretada ? "3mm" : "5mm",
        width: `${ancho}mm`,
        height: `${alto}mm`,
        padding: "10mm 10.6mm 7mm 27.5mm",
        fontFamily: "var(--font-rotulo-texto)",
      }}
      aria-label={`Etiqueta de tapa: ${datos.nombre_expediente || "sin nombre"}`}
    >
      <Ondas pieza="tapa" style={{ left: 0, top: 0, width: "21.2mm", height: "100%" }} />

      <header style={{ display: "flex", justifyContent: "space-between", gap: "6mm" }}>
        <div style={{ display: "grid", gap: "2mm", minWidth: 0, alignContent: "start" }}>
          <p style={versal(2.9, { color: "var(--impreso-texto-2)" })}>{encabezado}</p>
          <h1
            style={titular(datos.nombre_expediente.length > 34 ? 6.6 : 9.5, {
              letterSpacing: "-0.02em",
            })}
          >
            {datos.nombre_expediente}
          </h1>
          {versalita ? <p style={versal(3.4, { letterSpacing: "0.22em" })}>{versalita}</p> : null}
          {datos.empresa ? (
            <p style={dato(3.2, { color: "var(--impreso-texto-2)" })}>{datos.empresa}</p>
          ) : null}
        </div>
        <div style={{ flexShrink: 0 }}>
          <MarcaCompania compania={datos.compania} alto={19} />
        </div>
      </header>

      <div style={filete()} />

      <section>
        <p style={versal(2.9, { color: "var(--impreso-texto-2)", marginBottom: "1.2mm" })}>
          Contenido
        </p>
        {Array.from({ length: total }, (_, indice) => {
          const seccion = datos.secciones[indice]
          return (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: el índice ES el número impreso
              key={indice}
              style={{
                display: "flex",
                gap: "4.8mm",
                alignItems: "baseline",
                minHeight: apretada ? "6.2mm" : "9mm",
                padding: apretada ? "0.9mm 0" : "2.2mm 0",
                borderBottom: "0.26mm solid var(--impreso-filete)",
              }}
            >
              <span style={titular(3.6, { color: "var(--impreso-vino)", width: "5.3mm" })}>
                {seccion ? indice + 1 : ""}
              </span>
              <span style={dato(apretada ? 3.3 : 4.2)}>{seccion?.descripcion}</span>
            </div>
          )
        })}
      </section>
    </article>
  )
}
